export default {
  name: 'marking--docLinkType',
};